export default __webpack_public_path__ + "static/media/2.8f4347f3.png";